import styled from "styled-components"
import NetworkAd from "components/network-ad"

export const NetworkAdUnit = styled(NetworkAd)`
  max-width: 120rem;
  margin: 0 auto;
  padding: ${({ hideTitle }) => (hideTitle ? "0" : "1.2rem 0 5.2rem")};
  visibility: hidden;
  background-color: ${({ hideTitle }) => (hideTitle ? "white" : "transparent")};
  clear: both;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .network-ad {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`
